export enum TimelineEventType {
  PRIMARY_ETA_ON_TIME = 'PRIMARY_ETA_ON_TIME',
  PRIMARY_ETA_LATE = 'PRIMARY_ETA_LATE',
  ETA = 'ETA',
  CHECKIN = 'CHECKIN',
  CHECKOUT = 'CHECKOUT',
  HANDOVER_RELEASE = 'HANDOVER_RELEASE',
  HANDOVER_TAKE = 'HANDOVER_TAKE',
  HANDOVER_COMPLETE = 'HANDOVER_COMPLETE'
}
